import React, { useEffect, useState } from "react";
import SliderImage2 from '../Assets/SliderImage2.png';
import BackButton from "../Assets/BackButton.svg";
import NextButton from "../Assets/NextButton.svg";
import { Get_Api } from "../ApiUrls";

const DetailSlider = ({slides}) => {
   
    const [currentSlide, setCurrentSlide] = useState(0);


    const nextSlide = () => {
        setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    };

    return (
        <div className="detail-slider-container">
            {slides?.map((slide, index) => (
                <div
                    key={index}
                    className={`detail-slide ${index === currentSlide ? "detail-slide-active" : ""}`}
                    style={{ backgroundImage: `url(${slide?.Image})` }}>
                </div>
            ))}
            <img
                className="detail-nav-button detail-nav-left"
                onClick={prevSlide}
                style={{ width: '40px', height: '40px' }}
                src={BackButton}
                alt="Previous Slide"
            />
            <img
                className="detail-nav-button detail-nav-right"
                onClick={nextSlide}
                style={{ width: '40px', height: '40px' }}
                src={NextButton}
                alt="Next Slide"
            />
        </div>
    );
};

export default DetailSlider;
